var _excluded = ["min", "max", "step", "required", "requiredError", "validation"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { useTranslation } from 'react-i18next';
import TextField from '../TextField';
var Number = function Number(props) {
  var min = props.min,
    max = props.max,
    step = props.step,
    required = props.required,
    requiredError = props.requiredError,
    validation = props.validation,
    restProps = _objectWithoutProperties(props, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var handleValidation = function handleValidation(value) {
    if (required && !value) {
      return requiredError || t(['webform.number.required', 'webform.required', 'webform_required']);
    }
    if (min && parseInt(value) < min) {
      return t(['webform.components.number.min', 'webform.number.min', 'webform.min', 'webform_min'], {
        min: min
      });
    }
    if (max && parseInt(value) > max) {
      return t(['webform.components.number.max', 'webform.number.max', 'webform.max', 'webform_max'], {
        max: max
      });
    }
    if (validation) {
      return validation(value);
    }
  };
  return /*#__PURE__*/React.createElement(TextField, _extends({}, restProps, {
    type: "number",
    validation: handleValidation,
    min: min,
    max: max,
    step: step,
    required: required
  }));
};
export default Number;